export default __webpack_public_path__ + "static/media/Hair_12_M_C4.ada2fb4a.svg";